import { v4 as uuid } from 'uuid'
import { ElementPoint } from '@microservices/wiskey-react-components/dist/types'

import {
  AXIS_TYPE,
  BindField,
  GANTT_BIND_TYPE_LIST,
  GanttFormValues,
  SegmentType,
  TimelineItem,
  UNIT_INTERVAL_OPTIONS,
} from '@gantt/components/GanttCreateOrEdit'
import { EMPTY_COMMAND_FORM } from '@gantt/constants/forms'

export const DefReadAll = 'def_read_all'

export const contextMenuDefaultJson = [
  {
    name: 'Sorting',
    isHeader: true,
  },
  {
    name: 'Sort by ASC',
    command: 'sort',
    additionalData: {
      order: 'asc',
    },
  },
  {
    name: 'Sort by DESC',
    command: 'sort',
    additionalData: {
      order: 'desc',
    },
  },
  {
    isDivider: true,
  },
  {
    name: 'Unsort',
    command: 'unsort',
  },
]

export const contextMenuDefaultWithCommandJson = [
  {
    name: 'Get all',
    commands: [
      {
        name: 'object_read_all',
        httpMethod: 'GET',
      },
    ],
  },
]

export const tooltipDefaultTextJson = [
  {
    name: { bindType: 'static', static: 'text' },
    data: { bindType: 'static', static: 'value' },
    filler: 'value',
    parameters: [],
    itemType: 'text',
  },
]

export const tooltipDefaultGroupJson = [
  {
    name: { bindType: 'static', static: 'group' },
    itemType: 'group',
    items: tooltipDefaultTextJson,
  },
]

export const tooltipExampleJson: ElementPoint = [
  {
    elements: [
      {
        point: {
          bindType: 'static',
          value: 'Custom text',
          conditionsHidden: 'return false',
          background: 'none',
        },
        size: 3,
      },
      {
        point: {
          bindType: 'js',
          value: `return 'DATE NOW' + ' ' + moment().format("YYYY-MM-DD HH:mm:ss")`,
          conditionsHidden: 'return false',
          background: '#454545',
        },
        size: 5,
      },
      {
        point: {
          bindType: 'field',
          value: 'at',
          conditionsHidden: 'return false',
          background: '#454545',
        },
        size: 4,
      },
    ],
  },
  {
    elements: [
      {
        point: {
          bindType: 'js',
          value: `return 666`,
          conditionsHidden: 'return false',
          background: '#333333',
        },
        size: 6,
      },
      {
        point: {
          bindType: 'field',
          value: 'bt',
          conditionsHidden: 'return false',
          background: 'none',
        },
        size: 6,
      },
    ],
  },
]

export const timelineItemTitlesDefaultValue: BindField[] = []
export const timelineItemTitleDefaultValue: BindField = {
  bindType: GANTT_BIND_TYPE_LIST.STATIC,
  static: '',
  id: uuid(),
}

export const resourceColumnFieldDefaultValue: BindField = {
  bindType: GANTT_BIND_TYPE_LIST.FIELD,
  field: undefined,
  id: uuid(),
}

export const timelineItemDefaultValue: TimelineItem = {
  segmentType: SegmentType.MULTI,
  actions: [],
  additionalFields: [],
  commandVariables: [],
  tooltipVariables: [],
  contextMenuVariables: [],
  sections: [],
  data: null,
  commands: EMPTY_COMMAND_FORM,
  hasCorners: false,
  isMergeSegments: false,
  title: {
    bindType: GANTT_BIND_TYPE_LIST.FIELD,
    field: undefined,
  },
  tooltip: {
    bindType: GANTT_BIND_TYPE_LIST.FIELD,
    field: undefined,
  },
  background: {
    bindType: GANTT_BIND_TYPE_LIST.STATIC,
    static: undefined,
  },
  filter: {
    static: undefined,
    bindType: GANTT_BIND_TYPE_LIST.STATIC,
  },
  timeEdgesFilter: {
    static: undefined,
    bindType: GANTT_BIND_TYPE_LIST.STATIC,
  },
  key: {
    bindType: GANTT_BIND_TYPE_LIST.FIELD,
    field: undefined,
  },
  primaryKey: '',
  lines: {
    top: {
      has: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: false,
      },
      color: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      width: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: '',
      },
    },
    bottom: {
      has: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: false,
      },
      color: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      width: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: '',
      },
    },
  },
  borders: {
    inner: {
      has: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: false,
      },
      color: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      width: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: '',
      },
    },
    outer: {
      has: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: false,
      },
      color: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      width: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: '',
      },
    },
  },
  activeSegment: {
    has: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: true,
    },
    color: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: undefined,
    },
    opacity: '',
    verticalMargin: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: '',
    },
    sideMargin: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: '',
    },
  },
  textColor: {
    bindType: GANTT_BIND_TYPE_LIST.STATIC,
    static: undefined,
  },
  segmentHeight: {
    bindType: GANTT_BIND_TYPE_LIST.STATIC,
    static: '',
  },
  titles: [...timelineItemTitlesDefaultValue],
  boxVerticalGuideLines: {
    has: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: false,
    },
    isBoxColor: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: false,
    },
    color: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: undefined,
    },
    width: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: '1',
    },
    type: {
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
      static: 'dotted',
    },
  },
  isNew: true,
}

export const ganttConfigDefaultValue: GanttFormValues = {
  code: '',
  title: '',
  canvas: {
    axisX: {
      hasRealtimeLine: true,
      realtimeLineWidth: '2',
      realtimeLineColor: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: '#FF0000',
      },
      pastBackgroundColor: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      futureBackgroundColor: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      unitInterval: UNIT_INTERVAL_OPTIONS.HOUR,
      hasToolbar: false,
      isTimeWindow: true,
      extraVirtualizationCells: '',
      lines: {
        top: {
          has: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: false,
          },
          color: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: undefined,
          },
          width: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: undefined,
          },
        },
        bottom: {
          has: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: false,
          },
          color: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: undefined,
          },
          width: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: undefined,
          },
        },
      },
      borders: {
        inner: {
          has: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: false,
          },
          color: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: undefined,
          },
          width: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: '',
          },
        },
        outer: {
          has: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: false,
          },
          color: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: undefined,
          },
          width: {
            bindType: GANTT_BIND_TYPE_LIST.STATIC,
            static: undefined,
          },
        },
      },
      activeSegment: {
        has: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: true,
        },
        color: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: '#0088ff',
        },
        opacity: '0.35',
        verticalMargin: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: '8',
        },
        sideMargin: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: '12',
        },
      },
      textColor: {
        bindType: GANTT_BIND_TYPE_LIST.STATIC,
        static: undefined,
      },
      boxVerticalGuideLines: {
        has: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: false,
        },
        isBoxColor: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: undefined,
        },
        color: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: '#0012FF',
        },
        width: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: '1',
        },
        type: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: 'dotted',
        },
      },
      cursorVerticalGuideLine: {
        has: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: false,
        },
        color: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: undefined,
        },
        width: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: '1',
        },
        type: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: 'dashed',
        },
      },
    },
    axisY: {
      sortable: false,
      extraVirtualizationRows: '',
    },
    backgroundGridAppearance: {
      primaryLine: {
        type: 'dashed',
        displayValue: true,
        color: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: '#000000',
        },
        width: 1,
        spacing: 20,
        opacity: 1,
      },
      secondaryLine: {
        type: 'dotted',
        displayValue: true,
        color: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: '#808080',
        },
        width: 1,
        spacing: 10,
        opacity: 0.5,
      },
      horizontalLine: {
        type: 'solid',
        displayValue: true,
        color: {
          bindType: GANTT_BIND_TYPE_LIST.STATIC,
          static: '#808080',
        },
        width: 1,
        spacing: 1,
        opacity: 0.5,
      },
    },
    hasBacklog: false,
    rowHeight: '50',
    backlogHeight: '300',
    yAxisWidth: '461',
    xAxisWidth: '',
    noRealTime: false,
    hasRowExpansion: false,
    rowsExpansionAtStart: false,
    isResizableBacklog: false,
    isResizableY: false,
  },
  timeline: [
    {
      ...timelineItemDefaultValue,
    },
  ],
  resource: {
    additionalFields: [],
    commandVariables: [],
    tooltipVariables: [],
    contextMenuVariables: [],
    data: null,
    commands: EMPTY_COMMAND_FORM,
    columns: [],
    actions: [],
    filter: {
      static: '',
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
    },
    timeEdgesFilter: {
      static: '',
      bindType: GANTT_BIND_TYPE_LIST.STATIC,
    },
    key: {
      bindType: GANTT_BIND_TYPE_LIST.FIELD,
      field: undefined,
    },
    primaryKey: '',
  },
  sort: {
    axis: AXIS_TYPE.Y,
    code: '',
    value: [
      {
        field: null,
        order: null,
      },
    ],
  },
}
